export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10844.716becfe.jpg";